import styled from 'styled-components';
import { deviceMax } from '../../../../styles/MediaQuery';
import { darkGreen, greyLightBorder, greyLightButton, white } from '../../../../styles/Variables';

export const FiltersWrapper = styled.div`
    width: calc(100% - 42px);
    background: ${white};
    min-height: 10rem;
    grid-area: 2 / 1 / 3 / 5;
    border: 1px solid ${greyLightBorder};
    position: relative;
    top: -1px;
    padding: 20px;

    @media ${deviceMax.tablet} {
        grid-area: auto;
    }
`;

interface FiltersContentType {
    isEquipment?: boolean;
}

export const FiltersContent = styled.div<FiltersContentType>`
    display: grid;
    grid-template-columns: ${(props) => (props.isEquipment ? '150px 1fr' : 'repeat(3, 1fr)')};
    border-bottom: 1px solid ${greyLightBorder};

    :last-of-type {
        border: none;
    }
`;

export const FiltersContentLabel = styled.span`
    font-weight: 700;
    align-self: center;
`;

export const FiltersContentBox = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
`;

export const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 20px 0;

    label {
        margin-left: 1.25rem;
    }

    input[type='checkbox'] {
        cursor: pointer;
        width: 24px;
        height: 24px;
        margin-left: 1px;

        &:before {
            position: relative;
            display: block;
            width: 24px;
            height: 24px;
            content: '';
            background: ${greyLightButton};
            border: 1px solid ${greyLightBorder};
        }

        &:after {
            position: relative;
            display: block;
            width: 24px;
            height: 24px;
            top: -26px;
            content: '';
        }

        &:checked:after {
            position: relative;
            top: -25px;
            content: '✓';
            font-size: 2rem;
            color: ${darkGreen};
            text-align: center;
            line-height: 28px;
        }

        &:hover:not(:checked):after {
            position: relative;
            top: -25px;
            content: '✓';
            font-size: 2rem;
            color: ${darkGreen};
            text-align: center;
            line-height: 28px;
            opacity: 0.3;
        }
    }
`;

export const RadioButton = styled.label`
    display: block;
    position: relative;
    padding-left: calc(24px + 1.25rem);
    cursor: pointer;
    user-select: none;
    margin: 1.25rem 0;

    input[type='radio'] {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    span {
        position: absolute;
        top: -3px;
        left: 0;
        height: 24px;
        width: 24px;
        background: ${greyLightButton};
        border: 1px solid ${greyLightBorder};
        border-radius: 50%;

        &:after {
            content: '';
            position: absolute;
            display: none;
        }
    }

    input[type='radio']:checked ~ span {
        background: ${greyLightButton};
    }

    input[type='radio']:checked ~ span {
        background: ${greyLightButton};
    }

    input:checked ~ span:after {
        display: block;
    }

    span:after {
        top: 6px;
        left: 6px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: -webkit-linear-gradient(top, #94d232 0%, #8bba2b 100%);
        z-index: 1;
    }
`;

export const FiltersContentWrapper = styled.div``;
